<script>
	import { page } from '$app/stores';
</script>

<svelte:head>
	<title>Error</title>
</svelte:head>

<div
	class="flex min-h-screen flex-col items-center justify-center bg-gray-100 text-center text-gray-800"
>
	<img
		class="mb-8 w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5"
		data-src="https://takethecake.gumlet.io/resources/error - no bg.png"
		alt="A decorative gold frame with a whimsical design. At the top, there is the word 'Oops!' in a playful blue font, accompanied by small decorative elements like sparkles. Next to it, there are illustrations of a spatula and a whisk, also in blue. Below, in purple text, it says 'Something went a little off recipe!' At the bottom, there is an illustration of a spilled over bag of flour beside a pile of flour, suggesting a baking or cooking theme. The overall style is light-hearted and humorous."
	/>
	<h1 class="text-9xl font-bold text-red-600">{$page.status}</h1>
	{#if $page.error}
		<p class="mt-2 text-6xl font-bold">{$page.error?.message}</p>
	{/if}
	<p class="mb-8 mt-2 text-lg font-bold text-gray-600">
		Feel free to let us know if you think that this shouldn't have happened:
	</p>
	<p class="mt-2 flex flex-col gap-4">
		<a
			href="mailto:contact@envisionly.tech"
			class="inline-block text-sm text-logoBackgroundBlue underline underline-offset-4 transition hover:text-logobackgroundBlueRgba contrast-more:text-contrastColourTwo contrast-more:hover:text-contrastColourOne"
		>
			Email us</a
		>

		<a
			href="/"
			class="inline-block text-sm text-logoBackgroundBlue underline underline-offset-4 transition hover:text-logobackgroundBlueRgba contrast-more:text-contrastColourTwo contrast-more:hover:text-contrastColourOne"
			>Go back to the homepage</a
		>
	</p>
</div>